/* PDP only (loaded by sections/main-product.liquid): colour swatches show the full product photo instead of the app's square top-crop */
(function () {
  if (!document.body.classList.contains('product')) return;

  var SELECTOR =
    'product-info:not(quick-add-modal product-info) [option-name="Color"] .star-set-image[style*="crop="]';
  var scheduled = false;

  function fix() {
    scheduled = false;
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var style = el.getAttribute('style') || '';
      el.setAttribute(
        'style',
        style
          .replace(/&height=\d+/, '')
          .replace(/&crop=[a-z]+/i, '')
          .replace(/([?&])width=\d+/, '$1width=200')
      );
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(fix);
  }

  fix();

  // the swatch app renders late and re-renders on variant changes
  var root = document.querySelector('product-info') || document.body;
  new MutationObserver(schedule).observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style'],
  });
})();
